import Vue from 'vue';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
import VueLazyLoad from 'vue-lazyload';

Vue.use(VueLazyLoad);
